export type PortalTheme = "dark" | "light";

export const THEME_STORAGE_KEY = "wewall-theme";

export function currentTheme(): PortalTheme {
  if (typeof document === "undefined") return "dark";
  return document.documentElement.dataset.theme === "light" ? "light" : "dark";
}

// Persist the choice and reload so every Whop Elements embed remounts with
// the matching appearance config (Elements read it once at mount).
export function setTheme(theme: PortalTheme): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Private mode: the reload still applies the OS preference.
  }
  window.location.reload();
}
